import React, { Component } from 'react'
import { Row, Spin } from 'antd'
import { app, api, config } from "../../app"
import '../../css/expert.css'
import Head from "../../components/Head"
import Iconz from "../../components/Iconz"
import 'braft-editor/dist/output.css'

class EDetail extends Component {
    constructor (props) {
        super(props)
        this.state = {
            id: props.match.params.id,
            expert_info: {},
            detail_loading: true
        }
    }

    componentDidMount () {
        this._isMounted = true
        this.detailSource()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 详情数据
     */
    detailSource = async () => {
        const params = {
            id: this.state.id,
        }
        let { flag, data, msg } = await app.post(api.EDetail, params)
        const state = { detail_loading: false }
        if (flag === 1) {
            state.expert_info = data
        } else {
            app.alert(msg, 'error')
        }
        this.setData(state)
    }

    render () {
        let { expert_info, detail_loading } = this.state
        return (
            <div className="expert-page-detail">
                <Head notLogin={(
                    <div className="frame-head-logo">
                        <Iconz type="icon-logo_" size={48}/>
                    </div>
                )} background="#3F89C1" height={78} history={this.props.history}/>
                <div className="ep-content">
                    <div className="epc-title">专家资料</div>
                    <div className="epc-content">
                        {
                            detail_loading ? (
                                <div style={{textAlign: 'center'}}><Spin size="large"/></div>
                            ) : (
                                <div className="epc-detail">
                                    <Row type="flex" className="epcc-info">
                                        <div className="epcci-img">
                                            <img src={config.imgUrl + app.urlEncode(expert_info.head_img)} alt="头像"/>
                                        </div>
                                        <div className="epcci-news">
                                            <h2 className="epccin-name">{expert_info.name}</h2>
                                            <div className="epccin-item">
                                                <span className="epcci-t">职称类别：</span>
                                                <span className="epcci-c">{expert_info.positional}</span>
                                            </div>
                                            <div className="epccin-item">
                                                <span className="epcci-t">是否内部：</span>
                                                <span className="epcci-c">{expert_info.is_volunteer}</span>
                                            </div>
                                            <div className="epccin-item">
                                                <span className="epcci-t">聘用期限：</span>
                                                <span
                                                    className="epcci-c">{expert_info.employ_start} 至 {expert_info.employ_end}</span>
                                            </div>
                                        </div>
                                    </Row>
                                    <div className="epcc-item">
                                        <div className="epcci-title">专职类别</div>
                                        <div className="epcci-items">
                                            {
                                                (expert_info.ppe_class || []).map((p, i) => {
                                                    return (
                                                        <div className="epcci-ppe" title={p.name} key={i}>
                                                            <img className="peccip-img" src={config.imgUrl + p.icon} alt=""/>
                                                            <div className="peccip-name">{p.name}</div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                    <div className="epcc-item">
                                        <div className="epcci-title">个人介绍</div>
                                        <div className="epcci-items">
                                            <div className="braft-output-content"
                                                 dangerouslySetInnerHTML={{ __html: expert_info.descript }}
                                                 style={{ padding: '20px 0' }}/>
                                        </div>
                                    </div>
                                    <div className="epcc-item">
                                        <div className="epcci-title">个人履历</div>
                                        <div className="epcci-items">
                                            <div className="braft-output-content"
                                                 dangerouslySetInnerHTML={{ __html: expert_info.record }}
                                                 style={{ padding: '20px 0' }}/>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default EDetail



// WEBPACK FOOTER //
// ./src/routes/expert/EDetail.jsx